// START-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]
import { FullPageMessageCard } from '../full-page-message-card/full-page-message-card';
// /END-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]


interface InitializationErrorScreenProps {
    classification: 'NETWORK_ERROR' | 'SERVER_ERROR' | 'CHUNK_ERROR' | 'TIMEOUT_ERROR' | 'PARSING_ERROR' | 'UNKNOWN_ERROR';
}

// Exception: Startup fallback - translation context may not be loaded yet, hardcoded English strings are permitted here.
export function InitializationErrorScreen({ classification }: InitializationErrorScreenProps) {
    const handleReload = () => {
        window.location.reload();
    };

    const getTitle = () => {
        switch (classification) {
            case 'NETWORK_ERROR':
                return 'Connection Interrupted';
            case 'SERVER_ERROR':
                return 'Server Maintenance';
            case 'CHUNK_ERROR':
                return 'App Update in Progress';
            default:
                return 'Unexpected Error';
        }
    };

    const getMessage = () => {
        switch (classification) {
            case 'NETWORK_ERROR':
                return 'We are having trouble connecting to our servers. Please check your internet connection.';
            case 'SERVER_ERROR':
                return 'Our servers are currently experiencing issues or undergoing maintenance.';
            case 'CHUNK_ERROR':
                return 'An application update is in progress. Please reload to fetch the latest version.';
            default:
                return 'An unexpected error occurred during application initialization.';
        }
    };

    return (
        // START-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]
        <FullPageMessageCard
            title={getTitle()}
            message={getMessage()}
            actionLabel="Reload App"
            onAction={handleReload}
        />
    );
    // /END-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]
}
